import VueLib from 'vue'
import merge from 'lodash.mergewith'
import * as Sentry from '@sentry/browser'
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002F8fd00f8feb5f40c6b363c060063c785d@o1003030.ingest.sentry.io\u002F5970406",
    environment:"production",
    release:"v1.8.21",
    beforeSend:(event, hint) => {
                /* This code is all stuffed into this file instead of being
                 * in a separate file due to an apparent bug in the version
                 * of nuxt we're using: https://github.com/nuxt/nuxt.js/issues/8779
                 * It doesn't properly serialize functions imported from outside
                 * this file.
                 */
                var _a, _b, _c, _d, _e, _f, _g, _h;
                const privateKeyRedactionReplacement = '<PRIVATE KEY>';
                const generalRedactionReplacement = '<REDACTED>';
                function redactPrivateKeys(str) {
                    return str.replace(/[a-f0-9]{64}/gi, privateKeyRedactionReplacement);
                }
                function redactPrivateKeysIfString(str) {
                    if (typeof str === 'string') {
                        return redactPrivateKeys(str);
                    }
                    return str;
                }
                function redactCookies(cookies) {
                    const copy = { ...cookies };
                    Object.keys(copy).forEach(key => {
                        copy[key] = generalRedactionReplacement;
                    });
                    return copy;
                }
                if ((_a = event === null || event === void 0 ? void 0 : event.request) === null || _a === void 0 ? void 0 : _a.cookies) {
                    event.request.cookies = redactCookies(event.request.cookies);
                }
                if ((_c = (_b = event === null || event === void 0 ? void 0 : event.request) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.authorization) {
                    event.request.headers.authorization = generalRedactionReplacement;
                }
                if (event && !event.extra) {
                    event.extra = {};
                }
                const graphQLErrors = ((_e = (_d = hint === null || hint === void 0 ? void 0 : hint.originalException) === null || _d === void 0 ? void 0 : _d.graphQLErrors) !== null && _e !== void 0 ? _e : []);
                if ((event === null || event === void 0 ? void 0 : event.extra) && graphQLErrors.length > 0) {
                    graphQLErrors.forEach(error => {
                        error.message = redactPrivateKeys(error.message);
                    });
                    event.extra.graphQLErrors = graphQLErrors;
                }
                (_g = (_f = event === null || event === void 0 ? void 0 : event.exception) === null || _f === void 0 ? void 0 : _f.values) === null || _g === void 0 ? void 0 : _g.forEach(exception => {
                    exception.value = redactPrivateKeysIfString(exception.value);
                });
                if (event === null || event === void 0 ? void 0 : event.extra) {
                    event.extra.apiErrorIds = JSON.parse((_h = localStorage.getItem('apiErrorIds')) !== null && _h !== void 0 ? _h : '[]');
                }
                return event;
            }
  }

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  config.integrations = [
    new Dedupe({}),
    new ExtraErrorData({}),
    new ReportingObserver({}),
    new RewriteFrames({}),
    new Vue({ Vue: VueLib, ...{"attachProps":true,"logErrors":false}})
  ]

  /* eslint-enable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  Sentry.init(config)

  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
